const NotFound = () => {
  return (
    <div className="centered">
      <p>Page not Found</p>
    </div>
  );
};

export default NotFound;
